module.exports = __webpack_public_path__ + "frontend/images/signpost/green.jpg?8357a7019ea29fd6d1c2f2b4d5d31895";